import { render, staticRenderFns } from "./productionSummaryWidget.vue?vue&type=template&id=e508e0f8&"
import script from "./productionSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./productionSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports